import { render, staticRenderFns } from "./TheSpecifikacije.vue?vue&type=template&id=192117e2&scoped=true&"
import script from "./TheSpecifikacije.vue?vue&type=script&lang=js&"
export * from "./TheSpecifikacije.vue?vue&type=script&lang=js&"
import style0 from "./TheSpecifikacije.vue?vue&type=style&index=0&id=192117e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192117e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
